import {
    trackClick as trackClickImported,
    trackClickEvent as trackClickEventImported,
    trackComponentDisplayed,
    trackDOMComponentDisplayed,
} from '@edreamsodigeo/frontend-tracking-agent';
import catalog from './catalog';

const tracks = {
    COMPONENT: trackComponentDisplayed,
};

const trackHtmlEvent = (id, type) => {
    if (catalog.has(id)) {
        return tracks[type]({
            id,
        });
    }

    return Promise.resolve();
};
const getIdFromtTarget = (event) => {
    return event.currentTarget.dataset['id'];
};

const getDOMId = (htmlElement) => htmlElement.dataset['id'];

export const trackClickEvent = (event) => {
    if (event && event.currentTarget && catalog.has(getIdFromtTarget(event))) {
        return trackClickEventImported(event);
    } else {
        return Promise.reject({error: 'id not present on clicked event'});
    }
};

export const trackClick = (id) => {
    if (catalog.has(id)) {
        return trackClickImported({id});
    } else {
        return Promise.reject({error: 'id not present on clicked event'});
    }
};

/**
 * @deprecated This method will be deleted. Use trackDOMComponentDisplayed or TrackJQElement Displayed for $ elements
 * @param {String} id id of the component
 * @return {Promise} a promise with the sent event
 */
export const trackComponentDisplayedEvent = (id) => trackHtmlEvent(id, 'COMPONENT');

export const trackDOMElementDisplayed = (htmlElement) => {
    if (htmlElement && catalog.has(getDOMId(htmlElement))) {
        return trackDOMComponentDisplayed(htmlElement);
    } else {
        return Promise.reject({error: 'id not present on DOM element'});
    }
};

export const trackJQElementDisplayed = ($element) => {
    if ($element && $element[0]) {
        return trackDOMElementDisplayed($element[0]);
    } else {
        return Promise.reject({error: '$ element is null'});
    }
};

/**
 *
 * TODO: review this data mesh event added by additional products because it is using a deprecated `trackComponentDisplayedEvent` function
 * Use with caution because probably will be deprecated.
 */
export const trackOnce = (() => {
    const cache = {};

    return ($element) => {
        const id = $element.data('id');
        if (!cache[id]) {
            cache[id] = id;
            trackComponentDisplayedEvent(id);
        }
    };
})();
